/**
 * FridgeIQ — useSessions hook
 * Fetches and refreshes session data for a machine.
 */

import { useState, useEffect, useCallback } from "react";
import { getSessions, calcDayStats } from "../services/dynamodb";

export function useSessions(machineId) {
  const [sessions, setSessions] = useState([]);
  const [stats, setStats]       = useState(null);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const load = useCallback(async () => {
    if (!machineId) return;
    setLoading(true);
    setError(null);
    try {
      const { items } = await getSessions(machineId, { limit: 100 });
      setSessions(items);
      setStats(calcDayStats(items));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [machineId]);

  useEffect(() => { load(); }, [load]);

  return { sessions, stats, loading, error, refresh: load };
}
